import { VEHICLE_TYPES, VEHICLE_TYPE_EV } from '../../../../../constants/vehicleTypes';
import INTENT from '../../../../../constants/intent';

const SIMPLE_SEARCH_FIELDS = {
  [VEHICLE_TYPES.CARS]: ['l2CategoryId', 'model', 'PriceCents', 'constructionYear'],
  [VEHICLE_TYPES.VANS]: ['brand', 'transmission', 'PriceCents', 'constructionYear'],
  [VEHICLE_TYPES.OLDTIMERS]: ['brand', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPES.TRUCKS]: ['brand', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPE_EV]: ['l2CategoryId', 'model', 'PriceCents', 'range'],
};

export const SIMPLE_SEARCH_FIELDS_LEASE = {
  [VEHICLE_TYPES.CARS]: ['l2CategoryId', 'model', 'leaseTypeGroups', 'PriceCents', 'constructionYear'],
  [VEHICLE_TYPES.VANS]: ['brand', 'transmission', 'leaseTypeGroups', 'PriceCents', 'constructionYear'],
  [VEHICLE_TYPES.OLDTIMERS]: ['brand', 'leaseTypeGroups', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPES.TRUCKS]: ['brand', 'leaseTypeGroups', 'PriceCents', 'fuel', 'constructionYear'],
  [VEHICLE_TYPE_EV]: ['l2CategoryId', 'model', 'leaseTypeGroups', 'PriceCents', 'range'],
};

export const getSimpleSearchFields = (vehicleType: string, intent?: string) =>
  intent === INTENT.LEASE ? SIMPLE_SEARCH_FIELDS_LEASE[vehicleType] : SIMPLE_SEARCH_FIELDS[vehicleType];

export default SIMPLE_SEARCH_FIELDS;
